module.exports = __webpack_public_path__ + "static/media/react.6cebf308.png";